import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=94abecb2&scoped=true"
import script from "./CustomerSettings.vue?vue&type=script&lang=js"
export * from "./CustomerSettings.vue?vue&type=script&lang=js"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=94abecb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94abecb2",
  null
  
)

export default component.exports